<template>

  <el-main>

    <div style="background-color: #eeeeee; width: 100%; text-align: center; border-radius: 5px; margin: 5px 0;">
      <el-input v-model="keyword" @keypress.enter.native="getNavigationList" class="search" placeholder="请输入搜索内容">
        <i slot="suffix" class="el-input__icon el-icon-search icon-hover" @click="getNavigationList"/>
      </el-input>
    </div>

    <el-row style="width: 100%; padding: 0 20px;">
      <el-col :span="3">&nbsp;</el-col>
      <el-col :span="18" style="border-bottom: 1px solid #dcdfe6;"></el-col>
      <el-col :span="3">&nbsp;</el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="4" v-for="navigation in navigationList" :key="navigation.key">
        <el-link :href="navigation.url" :underline="false" style="width: 100px;height: 100px;">
          <el-image :src="navigation.icon" :alt="navigation.name" />
        </el-link>
        <div style="padding: 6px;">
          <el-link :href="navigation.url" :underline="false">
            <span style="line-height: 22px">{{navigation.name}}</span>
          </el-link>
          <div class="bottom clearfix">
            <time class="time" style="line-height: 22px">{{ navigation.created_at }}</time>
            <el-link type="primary" style="line-height: 22px" :href="'/nav/'+navigation.nid" :underline="false">查看详情</el-link>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-pagination
      background
      layout="prev, pager, next"
      :hide-on-single-page="true"
      :current-page.sync="page"
      :page-size="size"
      :total="total"
      @current-change="getNavigationList">
    </el-pagination>
  </el-main>

</template>

<script>
export default {
  name: 'NavigationList',
  data () {
    return {
      keyword: this.$route.query.hasOwnProperty('q') ? this.$route.query.q : '',
      navigationList: [],
      page: 1,
      size: 18,
      total: 0
    }
  },
  created: function () {
    document.title = '网湖 - 导航列表 - 网址导航|网站导航|网址大全|网站大全'
    this.$http.defaults.baseURL = process.env.VUE_APP_BASE_API
    this.getNavigationList()
  },
  methods: {
    getNavigationList () {
      this.$http.get('navigation/search?keyword=' + this.keyword + '&page=' + this.page + '&size=' + this.size, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then((response) => {
        if (response.data.code === 0) {
          this.total = response.data.data.total
          this.navigationList = response.data.data.list
        } else {
          this.$message({message: response.data.msg, type: 'error'})
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.el-main {
  padding: 0;
  text-align: center;
  min-height: 85vh;
}

/* 整体输入框的样式 */
.search {
  width: 600px;
  margin: auto;
}

.el-divider--horizontal {
  display: inline;
  width: 80%;
  margin: 0 0 5px 0;
}

.el-row {
  display: inline-block;
  width: 74%;
}

.el-col {
  margin-bottom: 1vh;
}

.el-image {
  width: 100px;
  height: 100px;
  border: 1px solid #CCCCCC;
  border-radius: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/NavigationList.vue